/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { IFestival, IProject, IRating } from "../data/interfaces";
import { IState, IUser, useMainStore } from "src/settings/zustand"; 
import actions from "../data/actions";
import { ID } from "src/libs/interfaces/layouts";
import { GET_PROJECT_STATISTICS } from "../data/actionTypes";
import { useSyncState } from "src/modules/pe-basic-module/hooks/useSyncState";
import { IFestDataStor, useFestDataStore } from "../data/store";

export interface IFestStatistics {
    isLoading: boolean
    projects: IProject[]
    users: IUser[]
    ratings: IRating[]
    phase: STATISTICS_LOADING_PHASE
    queueProjects: number
    queueFull: number
}
export enum STATISTICS_LOADING_PHASE {
    GET_PROJECTS,
    GET_USERS,
    GET_RATINGS,
}
export const PROJECT_PIECE = 200
export function useStatistics(): IFestStatistics {
    const landId: ID                    = useMainStore((state: IState) => state.landId)
    const festival: IFestival           = useFestDataStore((state: IFestDataStor) => state.festival) 
    const [isLoading,   setIsLoading]   = useState<boolean>(false)
    const projects                      = useSyncState<IProject[]>([])
    const users                         = useSyncState<IUser[]>([])
    const ratings                       = useSyncState<IRating[]>([])
    const offset                        = useSyncState<number>( 0 ) 
    const queueProjects                 = useSyncState<number>( 0 ) 
    const queueFull                     = useSyncState<number>( 0 ) 
    const phase                         = useSyncState<STATISTICS_LOADING_PHASE>( STATISTICS_LOADING_PHASE.GET_PROJECTS )
    useEffect(() => {
        const getProjects = () => {
            queueProjects.set( queueProjects.get() + 1 )
            queueFull.set( (festival.memberCount || PROJECT_PIECE) / PROJECT_PIECE )
            actions(GET_PROJECT_STATISTICS, {
                land_id: landId, 
                offset: offset.get(),
                phase: phase.get(),
            }).then( (response: any) => {
                offset.set( offset.get() + PROJECT_PIECE ) 
                const arr: any[] = [ ...projects.get(), ...response.getPEFestProjects ] 
                console.log( arr, arr.length, festival.memberCount )
                projects.set( arr )
                if( arr.length < (festival.memberCount || PROJECT_PIECE)) {
                    getProjects()
                }
                else {
                    phase.set( STATISTICS_LOADING_PHASE.GET_USERS )
                    getUsers()
                }
            })
        }
        const getUsers = () => {
            actions(GET_PROJECT_STATISTICS, {
                land_id: landId, 
                phase: phase.get(),
            }).then( (response: any) => { 
                users.set( response.getUsers ) 
                phase.set( STATISTICS_LOADING_PHASE.GET_RATINGS )
                getRatings()
            })
        }
        const getRatings = () => {
            actions(GET_PROJECT_STATISTICS, {
                land_id: landId, 
                phase: phase.get(),
            }).then( (response: any) => { 
                ratings.set( response.getPEFestRatings )
                setIsLoading( true )
                console.log( projects.get(), users.get(), ratings.get() )
            })
        }
        getProjects()
    }, [])
    return {
        isLoading,
        projects: projects.get(),
        users: users.get(),
        ratings: ratings.get(),
        phase: phase.get(),
        queueProjects: queueProjects.get(),
        queueFull: queueFull.get(),
    }
}